<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title section__title section__title_style3">
                <slot name="title"></slot>
            </div>
            <button class="btn svg-icon modal-close" type="button" data-dismiss="modal" aria-label="Закрыть">
              <svg role="img" width="14" height="14" aria-hidden="true">
                <use xlink:href="#svg-icon-close"></use>
              </svg>
            </button>
          </div>
          <div class="modal-body">
            <slot name="body"></slot>
          </div>
        </div>
      </div>
    </div>    
</template>
<script>
export default {
    name: 'modal-window',
}
</script>
<style>

</style>